const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon-drink-primary{fill:#008941;}"));
var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "icon-drink-primary",
  d: "M4.5,3,7.013,25.787A2.5,2.5,0,0,0,9.5,28H22a2.5,2.5,0,0,0,2.487-2.213L27,3ZM15.75,24.25A3.745,3.745,0,0,1,12,20.5c0-2.5,3.75-6.75,3.75-6.75S19.5,18,19.5,20.5A3.745,3.745,0,0,1,15.75,24.25ZM23.662,10.5H7.838l-.55-5H24.2Z",
  transform: "translate(-4.5 -3)"
});
function SvgIconmaterialLocalDrinkPrimary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.5,
    height: 25,
    viewBox: "0 0 22.5 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconmaterialLocalDrinkPrimary);
export default __webpack_public_path__ + "static/media/Icon material-local-drink-primary.f2d21814.svg";
export { ForwardRef as ReactComponent };